import gql from 'graphql-tag';

import {
  AlbumFolderMainCoverPhoto,
  AlbumFolderPrintAssets,
} from '../../../../../../../graphql/fragments/album-folder';
import { PhotoThumbnails } from '../../../../../../../graphql/fragments/album';

export const MatchesAlbumFolderDetails = gql`
  fragment MatchesAlbumFolderDetails on AlbumFolder {
    id
    name
    join_code
    join_type
    joins_enabled
    matching_disabled
    org_pay_photo_pricing_enabled
    album_type
    album_subtype
    upload_mode
    file_comment_privacy
    picture_day_enabled
    is_demo
    default_album_delivery_mode
    has_album_photos
    all_photos_mode
    join_type
    is_web_gallery
    green_screen_enabled
    has_charity
    charity_description
  }
`;

export const MatchesAlbumFolderChildrenDetails = gql`
  fragment MatchesAlbumFolderChildrenDetails on AlbumFolder {
    children {
      album_folders(slice: { limit: 999 }) {
        total
        records {
          id
          name
          updated_at
          is_web_gallery
          cover_photos {
            records {
              faces_box
              ...PhotoThumbnails
            }
          }
          ...AlbumFolderMainCoverPhoto
        }
      }
      albums(
        slice: { limit: 999 }
        exclude_albums_with_viewer_album_membership: $exclude_albums_with_memberships
      ) {
        total
        records {
          id
          name
          cover_photo {
            faces_box
            ...PhotoThumbnails
          }
          join_code
          last_uploaded_at
          is_web_gallery
        }
      }
    }
  }
  ${AlbumFolderMainCoverPhoto}
  ${PhotoThumbnails}
`;

export const AlbumFolderForPrintAssetDetails = gql`
  fragment AlbumFolderForPrintAssetDetails on AlbumFolder {
    id
    album_folder_print_packages(slice: { limit: 999 }) {
      total
      records {
        id
        print_package {
          id
          print_assets(slice: { limit: 999 }) {
            total
            records {
              id
              print_asset {
                id
                name
                type
                jersey_colors(slice: { limit: 999 }) {
                  records {
                    id
                    jersey_color
                  }
                }
                asset_image {
                  id
                  url
                  width
                  height
                }
              }
            }
          }
        }
      }
    }
    photo_pricing {
      id
      print_assets(slice: { limit: 999 }) {
        total
        records {
          id
          print_asset {
            id
            name
            type
            jersey_colors(slice: { limit: 999 }) {
              records {
                id
                jersey_color
              }
            }
            asset_image {
              id
              url
              width
              height
            }
          }
        }
      }
    }
    ...AlbumFolderPrintAssets
  }
  ${AlbumFolderPrintAssets}
`;
